const hash = { start: 'end', end: 'start' };

export const getOppositeAlignmentPlacement = (placement) =>
  placement.replace(/start|end/g, (matched) => hash[matched]);
